import * as React from 'react';
import * as styles from './slonoTopFooter.css';
import { Address } from '../../offer-card/components/address';
import { SlonoTopTitle } from '../title/slonoTopTitle';
import { RightPanel } from '../../common/components/RightPanel';
import * as slonoTopCardStyles from '../slonoTopCard.css';
import { IOffer } from '../../types/offer';
import { IComplaintsHelpers } from '../../types/complaints';
import { IOfferCardComponentsProps } from '../../offer-card';
import { TopPrice } from '../../TopOfferCard/TopPrice';
import { SlonoTopDescription } from '../description/slonoTopDescription';
import { JkName } from '../../offer-card/components/jk_name';
import { LandArea } from '../../offer-card/components/land-area';
import { LeasePeriod } from '../../offer-card/components/lease_period';
import { Deadline } from '../../offer-card/components/deadline';
import { LandStatus } from '../../offer-card/components/land-status';
import { mergeStyles } from '@cian/utils';
import { Comments } from '../../common/components/comments';
import { Map } from '../../common/components/map';
import { Buttons } from '../../offer-card/components/buttons';

export interface ISlonoTopFooterProps {
  currentPath: string | undefined;
  suggestionDistancesSeoText: string | undefined;
  complaintsHelpers: IComplaintsHelpers;
  position: number;
  agentPhone: string | undefined;
  isPhoneHidden: boolean;
  isSimilar: boolean;
  offer: IOffer;
  api: IOfferCardComponentsProps;
  currentSubdomain: string;
  qsToUris?: { [key: string]: string; };
  isCommentAreaOpened: boolean;
  isMapActive: boolean;
  isMapLoaded: boolean;
  isComplainOpen: boolean;
  isHideOfferFetching?: boolean;
  isOnHideAnimation?: boolean;

  toggleCallbackModal(): void;

  handleHideFromPrintClick(): void;

  onDescriptionClick(evt: MouseEvent): void;

  onComplainClose(): void;

  handleButtonMapClick(): void;

  handleCommentClick(): void;

  handleCommentingCompletion(): void;

  handleTitleClick(e: React.MouseEvent<HTMLAnchorElement>): void;

  onFavoriteChange(isFavorite: boolean): void;
}

export const SlonoTopFooter = (props: ISlonoTopFooterProps) => {

  const {
    currentPath,
    qsToUris,
    suggestionDistancesSeoText,
    offer,
    complaintsHelpers,
    position,
    agentPhone,
    api,
    isPhoneHidden,
    isSimilar,
    currentSubdomain,
    isMapActive,
    isMapLoaded,
    isComplainOpen,
    isCommentAreaOpened,
    isHideOfferFetching,
    isOnHideAnimation,
    handleHideFromPrintClick,
    toggleCallbackModal,
    handleTitleClick,
    onDescriptionClick,
    onComplainClose,
    handleButtonMapClick,
    handleCommentClick,
    handleCommentingCompletion,
    onFavoriteChange,
  } = props;

  return (
    <div className={ styles['slono-top_footer'] }>
      <div className={ styles['footer_main'] }>
        <div className={ styles['footer-left'] }>
          <Address
            currentPath={ currentPath }
            qsToUris={ qsToUris }
            suggestionDistancesSeoText={ suggestionDistancesSeoText }
            hideDot
          />
          <div onClick={ e => e.stopPropagation() }>
            <JkName/>
          </div>
          <Deadline/>
          <LeasePeriod/>
          <LandStatus/>
          <LandArea/>
        </div>
        <div className={ styles['footer-right'] }>
          <div className={ styles['main-info'] }>

            <div className={ styles['title'] }>
              <SlonoTopTitle handleTitleClick={ handleTitleClick }/>
            </div>

            <div className={ styles['main-info_top_price'] }>
              <TopPrice
                mortgageBanner={ api.mortgageBanner }
                currentSubdomain={ currentSubdomain }
                excludedUtilitiesTermsRegions={api.excludedUtilitiesTermsRegions}
              />
              { api.mortgageBanner }
            </div>
          </div>
          <div>
            <SlonoTopDescription
              onClick={ onDescriptionClick }
              description={ offer.description || '' }
              link={ offer.fullUrl }
            />
          </div>
          <div className={ styles['panels_container'] }>
            <Buttons
              position={ position }
              isMapActive={ isMapActive }
              onHideFromPrintClicked={ handleHideFromPrintClick }
              onMapButtonClick={ handleButtonMapClick }
              isCallbackVisible={ !!agentPhone }
              onCallbackClick={ toggleCallbackModal }
              //tslint:disable-next-line:no-any
              offer={ (offer as any) }
              containerClassName={ slonoTopCardStyles['bottom-panel'] }
              onCommentClick={ handleCommentClick }
              buttonClassName={ slonoTopCardStyles['button'] }
              dynamicButtonClassName={ slonoTopCardStyles['dynamic-button'] }
              //tslint:disable-next-line:no-any
              onFavoriteChange={ onFavoriteChange }
              isComplainOpen={ isComplainOpen }
              onComplainClose={ onComplainClose }
              isSimilar={ isSimilar }
              isPhoneHidden={ isPhoneHidden }
              isMoreInfoHidden={ true }
              isSimplified
              complaintsHelpers={ complaintsHelpers }
              isHideOfferFetching={ isHideOfferFetching || isOnHideAnimation }
            />
            <RightPanel/>
          </div>
        </div>
      </div>
      <div>
        {
          (isCommentAreaOpened || offer.notes.offer || offer.notes.realtor) && (
            <div onClick={ e => e.stopPropagation() } className={ styles['sub-block'] }>
              <Comments
                offer={ offer }
                isSimplified
                onCompletion={ handleCommentingCompletion }
                { ...api.comments }
              />
            </div>
          )
        }

        { offer.geo && offer.geo.coordinates && (
          <div { ...mergeStyles(
            styles['map-container'],
            isMapActive && styles['map-active'],
          ) } >
            <div className={ styles['map'] }>
              { isMapLoaded && <Map coordinates={ offer.geo.coordinates }/> }
            </div>
          </div>
        ) }
      </div>
    </div>
  );
};
